module.exports = __webpack_public_path__ + "static/lululemon-chip-logo-1456a6446d9541abb93e7f3ce59d88f8.png";